import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LoadingGroup, Pager, Spinner, Table, useSimpleTableDataSource } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Subheading } from "capitalrx-components-2.0/lib/typography";

import { UniformRowColorTable } from "@/App/components";

import { useGetEligibilityMemberHoursWorkHistoryQuery } from "../../api";
import { MemberHoursWorkHistoryBaseType } from "../../interface";

export const Timesheet = () => {
  const { t: translate } = useTranslation();

  const { data: workHistoryData, isLoading: workHistoryDataIsLoading } = useGetEligibilityMemberHoursWorkHistoryQuery();

  const workHistoryRows = useMemo(() => {
    return (workHistoryData?.results || []).map((work_history: MemberHoursWorkHistoryBaseType) => {
      return {
        id: work_history.id,
        data: {
          ...work_history,
        },
      };
    });
  }, [workHistoryData]);

  const workHistoryDataSource = useSimpleTableDataSource(workHistoryRows, { pageSize: 10 });

  return (
    <LoadingGroup loading={workHistoryDataIsLoading}>
      <LoadingGroup.Placeholder
        fallback={
          <Shelf>
            <Spinner size="large" />
          </Shelf>
        }
      >
        <Stack>
          <Stack spacing="large">
            <Subheading>{translate("ELIGIBILITY.timesheet")}</Subheading>
            <UniformRowColorTable
              dataSource={workHistoryDataSource}
              footer={<Pager dataSource={workHistoryDataSource} testId="work_history_table_pagination" />}
            >
              <Table.Date name="updated_at" title={translate("ELIGIBILITY.dateAdded")} initialWidth="span" format="MM/dd/yyyy" />
              <Table.Text name="hours_worked" title={translate("ELIGIBILITY.hoursBanked")} initialWidth="span"/>
              <Table.Text name="employer_name" title={translate("ELIGIBILITY.employer")} initialWidth="span" />
              <Table.Text name="work_period" title={translate("ELIGIBILITY.workPeriod")} initialWidth="span" />
            </UniformRowColorTable>
          </Stack>
        </Stack>
      </LoadingGroup.Placeholder>
    </LoadingGroup>
  );
};
